import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";
import VehicleTypeSelect from "@CheckOrder/features/addons/features/jadrolinija/components/VehicleTypeSelect";
import Translation from "@Translation/components/Translation";

type VehiclesProps = {
    addonData: VehicleAddonResponseType[],
}

function Vehicles({addonData}: VehiclesProps) {
    return (
        <div className="ticket-addons__container">
            <span className="gb--row gb--row-justify gb--row-wrap gb--card-title">
                <Translation translationKey="check_order.addons.JADL.vehicle.title"/>
            </span>
            <VehicleTypeSelect
                vehicles={addonData}
            />
        </div>
    );
}

export default Vehicles;